// Admin-wide source of truth for chat/call classification.
// Legacy Exotel calls can have session_info.mode="chat".
export const getAdminConsultationMode = (consultation) =>
  String(consultation?.session_info?.callModeCourier || "").toLowerCase() === "exotel"
    ? "call"
    : "chat";
